// extracted by mini-css-extract-plugin
export default {"wrapper":"dashboard_wrapper__-E6Ie"};